import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const Banner = () => {
  return (
    <section className="banner-section index-8">
      <div className="overlay">
        <div className="banner-content pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <h1>Real-time payment alerts that keep you ahead</h1>
                  <p className="xxlr">
                    Know the second an invoice clears, a conversion completes, or
                    someone logs in from a new device—before your client has to
                    chase you.
                  </p>
                  <Link href={getDashboardPathUrl("/register")} className="cmn-btn">
                    Configure alerts
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
